import React from 'react'

import twitterImage from '../../../../../public/static/images/svg/twitterLogo.svg'

const TwitterLogo = (props) => {
  return (
    <a href="https://twitter.com/winit_app" target="_blank" rel="noopener noreferrer">
      <img src={twitterImage} alt="twitter logo" />
    </a>
  )
}

export default TwitterLogo